module.exports = {
	"config": {
		"siteTitle": "AI lectures",
		"baseColor": "#004d40",
		"linkPrefix": "/",
		"docPages": [
			"/docs/",
			"/docs/l-1/",
			"/docs/l-2/",
			"/docs/l-3/",
			"/docs/l-4/",
			"/docs/l-5/",
			"/docs/l-6/",
			"/docs/l-7/",
			"/docs/l-8/",
			"/docs/l-9/",
			"/docs/l-10/",
			"/docs/l-11/",
			"/docs/l-12/",
			"/docs/l-13/",
			"/docs/l-14/",
			"/docs/l-15/"
		]
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "docs",
				"stem": "_template",
				"path": "docs\\_template.jsx"
			},
			"requirePath": "docs/_template.jsx",
			"templatePath": "/docs/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs",
				"stem": "index",
				"path": "docs\\index.md"
			},
			"requirePath": "docs/index.md",
			"path": "/docs/",
			"data": {
				"title": "Trivia"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\l-1",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/l-1",
				"stem": "index",
				"path": "docs\\l-1\\index.md"
			},
			"requirePath": "docs/l-1/index.md",
			"path": "/docs/l-1/",
			"data": {
				"title": "1. Основные понятия + Теория силлогизмов"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\l-10",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/l-10",
				"stem": "index",
				"path": "docs\\l-10\\index.md"
			},
			"requirePath": "docs/l-10/index.md",
			"path": "/docs/l-10/",
			"data": {
				"title": "10. Естественный язык (математическая модель): анализ трансформационных грамматик"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\l-11",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/l-11",
				"stem": "index",
				"path": "docs\\l-11\\index.md"
			},
			"requirePath": "docs/l-11/index.md",
			"path": "/docs/l-11/",
			"data": {
				"title": "11. Проблема машинного перевода (ATN)"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\l-12",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/l-12",
				"stem": "index",
				"path": "docs\\l-12\\index.md"
			},
			"requirePath": "docs/l-12/index.md",
			"path": "/docs/l-12/",
			"data": {
				"title": "12. Этапы анализа естественного языка"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\l-13",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/l-13",
				"stem": "index",
				"path": "docs\\l-13\\index.md"
			},
			"requirePath": "docs/l-13/index.md",
			"path": "/docs/l-13/",
			"data": {
				"title": "13. Экспертные системы: технология, этапы создания, применение"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\l-14",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/l-14",
				"stem": "index",
				"path": "docs\\l-14\\index.md"
			},
			"requirePath": "docs/l-14/index.md",
			"path": "/docs/l-14/",
			"data": {
				"title": "14. Использование онтологий в интеллектуальных системах"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\l-15",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/l-15",
				"stem": "index",
				"path": "docs\\l-15\\index.md"
			},
			"requirePath": "docs/l-15/index.md",
			"path": "/docs/l-15/",
			"data": {
				"title": "15. Агентный подход к ИИ"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\l-2",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/l-2",
				"stem": "index",
				"path": "docs\\l-2\\index.md"
			},
			"requirePath": "docs/l-2/index.md",
			"path": "/docs/l-2/",
			"data": {
				"title": "2. Формальные и семиотические системы"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\l-3",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/l-3",
				"stem": "index",
				"path": "docs\\l-3\\index.md"
			},
			"requirePath": "docs/l-3/index.md",
			"path": "/docs/l-3/",
			"data": {
				"title": "3. Семантические сети"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\l-4",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/l-4",
				"stem": "index",
				"path": "docs\\l-4\\index.md"
			},
			"requirePath": "docs/l-4/index.md",
			"path": "/docs/l-4/",
			"data": {
				"title": "4. Представление знаний с помощью фреймов"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\l-5",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/l-5",
				"stem": "index",
				"path": "docs\\l-5\\index.md"
			},
			"requirePath": "docs/l-5/index.md",
			"path": "/docs/l-5/",
			"data": {
				"title": "5. Продукционные системы. Управление системами продукций"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\l-6",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/l-6",
				"stem": "index",
				"path": "docs\\l-6\\index.md"
			},
			"requirePath": "docs/l-6/index.md",
			"path": "/docs/l-6/",
			"data": {
				"title": "6. Логические модели представления знаний"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\l-7",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/l-7",
				"stem": "index",
				"path": "docs\\l-7\\index.md"
			},
			"requirePath": "docs/l-7/index.md",
			"path": "/docs/l-7/",
			"data": {
				"title": "7. Технологии инженерии знаний"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\l-8",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/l-8",
				"stem": "index",
				"path": "docs\\l-8\\index.md"
			},
			"requirePath": "docs/l-8/index.md",
			"path": "/docs/l-8/",
			"data": {
				"title": "8. Естественный язык (математическая модель): формальные грамматики"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs\\l-9",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/l-9",
				"stem": "index",
				"path": "docs\\l-9\\index.md"
			},
			"requirePath": "docs/l-9/index.md",
			"path": "/docs/l-9/",
			"data": {
				"title": "9. Естественный язык (математическая модель): трансформационная грамматика, понятие глубинной и поверхностной структуры"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md"
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {
				"title": "Лекции по ИИ от Ворониной И.Е."
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 381
// module chunks = 0